import { ColorModeContext, useMode } from "./theme";
import { ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Layout from "./Component/Layout/Layout";
import PrivateRoute from "./Routes/PrivetRoute";
import { useDispatch } from "react-redux";
import { loadUserApi } from "./state/action/authAction";
import { useEffect } from "react";

const App = () => {
  const [theme, colorMode] = useMode();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserApi());
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route
            path="*"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
